// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"bd979714","496":"0bb91a0d","896":"54c50c50","941":"3ea80773","951":"1fe7fa9b"}[chunkId] + ".chunk.js";
};